import { useEffect, useRef } from 'react'

/** Calls onIdle after timeoutMs without pointer or keyboard activity. */
export function useIdleReset(
  active: boolean,
  timeoutMs: number,
  onIdle: () => void,
): void {
  const onIdleRef = useRef(onIdle)
  onIdleRef.current = onIdle

  useEffect(() => {
    if (!active) return undefined
    let timeoutId = window.setTimeout(() => {
      onIdleRef.current()
    }, timeoutMs)
    const resetTimeout = (): void => {
      window.clearTimeout(timeoutId)
      timeoutId = window.setTimeout(() => {
        onIdleRef.current()
      }, timeoutMs)
    }
    window.addEventListener('pointerdown', resetTimeout)
    window.addEventListener('keydown', resetTimeout)
    return () => {
      window.clearTimeout(timeoutId)
      window.removeEventListener('pointerdown', resetTimeout)
      window.removeEventListener('keydown', resetTimeout)
    }
  }, [active, timeoutMs])
}
